import styled from 'styled-components';
import { Link } from 'react-router-dom';

const MovePage = styled.span`
  display: inline-block;
  width: 33px;
  border-radius: 33px;
  cursor: pointer;
  line-height: 33px;
  color: ${({ theme }) => theme.mainColor};

  /* stylelint-disable */
  @media (hover: hover), screen and (-ms-high-contrast: active), screen and (-ms-high-contrast: none) {
    &:hover {
      opacity: 0.75;
    }
  }
  /* stylelint-enable */

  svg {
    position: relative;
    top: 5px;
  }
`;

export const MovePageLink = MovePage.withComponent(Link);
